import { Pipe, PipeTransform } from "@angular/core";

/** Groups the integer part with a space every 3 digits: 10000 -> "10 000". */
@Pipe({
  name: "priceFormat",
})
export class PriceFormatPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    const num = typeof value === "number" ? value : Number(value);
    if (!Number.isFinite(num)) {
      return String(value);
    }

    const isNegative = num < 0;
    const rounded = Math.round(Math.abs(num) * 100) / 100;
    const [intPart, decPart] = rounded.toString().split(".");
    const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

    return `${isNegative ? "-" : ""}${grouped}${decPart ? "." + decPart : ""}`;
  }
}
